import { GenericTableColumnsInterface, MappedTableColumnsInterface } from '../../../app.interfaces';
import { EVENTS } from '../../../_helpers/constants';

export const TABLE_COLUMNS: GenericTableColumnsInterface = {
    orderBook: {
        'info': 'Info',
        'modified': 'Time',
        'order_mode': 'Mode',
        'symbol': 'Symbol',
        'last_trade_price': 'Ltp',
        'market_id': 'Exchange',
        'product_type': 'Product',
        'quantity': 'Qty',
        'price': 'Price',
        'order_status': 'Order Status',
        'client_order_id': 'Order ID',
        'order_type': 'Order Type',
        'pending_qty': 'Pending Qty',
        'stop_price': 'Stop Price',
        // 'created': 'Time',
        'original_client_order_id': 'Original Order ID',
        'exchange_order_id': 'Exchange Order ID',
        'last_filled_qty': 'Last Filled Qty',
        'last_filled_price': 'Last Filled Price',
        'total_filled_qty': 'Filled Qty',
        'is_trigerred': 'Triggered Status',
        'order_category': 'Order Category',
        'childClCode': 'Child Cl Code',
        'order_validity': 'Validity',
        'error_text': 'Messages',
        'instrument_type': 'Instrument type',
        'generated_order_id': 'Generated Order ID',
        'placed_by': 'Placed By',
        'modified_by': 'Modified By'
    },

    tradeBook: {
        'history': 'History',
        'modified': 'Time',
        'side': 'Mode',
        'scrip_name': 'Symbol',
        'last_trade_price': 'Ltp',
        'market_id': 'Exchange',
        'product_type': 'Product',
        'last_filled_qty': 'Qty',
        'last_fill_price': 'Price',
        'client_order_id': 'Order Id',
        // 'order_type',
        'status': 'Order Status',
        'exchange_order_id': 'Exchange Order Id',
        'primary_client_code': 'Primary Client Code',
        'trade_id': 'Trade Id',
        'order_validity': 'Order Validty',
        // not listed in mail. to be verified
        'instrument': 'Instrument type',
        'last_traded_amount': 'Last Traded Amount',
        'participant_code': 'Participant Code',
        'exchange_client_code': 'Exchange Client Code',
        'fix_cl_order_id': 'Fix Order Id',
        'clientId': 'Client Id',
        'order_category': 'Order Category',
        'placed_by': 'Placed By',
        'generated_order_id': 'Generated Order ID'
    },

    positions: {
        'action-btns': 'Action Buttons',
        'product_type': 'Product',
        'scrip_name': 'Symbol',
        'netQuantity': 'Net Qty',
        'net_price': 'Net Price',
        'last_trade_price': 'Ltp',
        'net_profit_loss': 'Net P/L',
        'market_id': 'Exchange',
        'instrument': 'Instrument Type',
        'net_value': 'Net Value',
        'm2m': 'Net M2M P/L',
        //'day_m2m': 'Day M2M P/L', commenting as it is not required for now
        'booked_pl': 'Booked P/L',
        'buy_qty': 'Buy Qty',
        'buy_lots': 'Buy Lots',
        'buy_price': 'Avg Buy Price',
        'buy_amount': 'Buy Amount',
        'sell_qty': 'Sell Qty',
        'sell_lots': 'Sell Lots',
        'sell_price': 'Avg Sell Price',
        'sell_amount': 'Sell Amount',
        // 'series',
        'primary_client_code': 'Parent CI Code'
    },

    marginSummaryColumns: {
        'client_code': 'Client Code',
        'cash': 'Cash',
        'cash_available': 'Cash Available',
        'collateral': 'Collateral',
        'net_mtm': 'Net MTM',
        'mtm_profit': 'MTM Profit',
        'delivery_selling_benifit': 'Delivery Selling Benefit',
        'booked_profit': 'Booked Profit',
        'pay_in': 'Pay In',
        'adhoc': 'AdHoc',
        'margin_utilized': 'Margin Utilized',
        'margin_percent': 'Margin Percent',
        'net_booked_profit_loss': 'Net Booked Profit Loss',
        'mtm_loss': 'MTM Loss',
        'mtm_percent': 'MTM Percent',
        'booked_loss': 'Booked Loss',
        'pay_out': 'Pay Out'
    },

    holdings: {
        'action': 'Action Button',
        'symbol': 'Symbol',
        'total_qty': 'Total Qty',
        'last_trade_price': 'Ltp',
        'current_value': 'Current Value',
        'profit_loss': 'Profit Loss',
        'outStandingQty': 'Balance Qty',
        'isin': 'ISIN',
        'pending_qty': 'Pending Qty',
        'sold_qty': 'Sold Qty',
        'close_price_value': 'Close Price',
        'average_price': 'Average Price',
        'investment_value': 'Invested Value',
        'client_id': 'Client Id',
        'avilableQty': 'Holding Qty',
        'collateral_qty': 'Total Collateral Qty',
        'collateralValue': 'Collateral Value',
        't1_qty': 'T1 Holding',
        'edis_auth_qty': 'Authorization Qty'
    },

    productConversionSummary: {
        'symbol': 'Symbol',
        'market_id': 'Exchange',
        'security_id': 'SecurityId',
        'initiator': 'Performed By',
        'instrument_type': 'Instrument type',
        'quantity': 'Qty Converted',
        'source_product': 'Old Product',
        'target_product': 'New Product',
        'status': 'Status',
        'rejectionText': 'Rejection Text',
        'mode': 'Mode',
        'client': 'Client Id'
    },

    batchOrdersTable: {
        'select': 'Select',
        'id': 'S.No.',
        'client': 'ClientID',
        'status': 'Status',
        'symbol': 'Symbol',
        'last_trade_price': 'Ltp',
        'orderMode': 'Buy/Sell',
        'price': 'Price',
        'orderType': 'Order Type',
        'quantity': 'Quantity',
        'market': 'Exchange',
        'instrument': 'Instrument',
        'series': 'Series',
        'securityId': 'SecurityID',
        'expiryDate': 'ExpiryDate',
        'optType': 'Option Type',
        'strikePrice': 'Strike Price',
        'triggerPrice': 'Trigger Price',
        'product': 'Product',
        'validity': 'Validity'
    },
    fundsBook: {
        time: 'Transaction Time',
        ut_transaction_id: 'Order ID',
        amount: 'Amount',
        mode: 'Mode',
        payment_gateway: 'Gateway',
        bank_name: 'Bank Name',
        status: 'Status',
        delete_request: 'Delete Request',
    }
};

export const TABLE_COLUMNS_STATIC_DYANMIC_MAPPING: MappedTableColumnsInterface = {

    orderBook: {
        static: {
            // 'cancelModifyOrder': 'cancelModify',
            'info': 'Info',
            'modified': 'Time',
            'order_mode': 'Mode',
            'symbol': 'Symbol',
            'last_trade_price': 'Ltp',
            'market_id': 'Exchange',
            'product_type': 'Product',
            'quantity': 'Qty',
            'pending_qty': 'Pending Qty',
            'price': 'Price',
            'order_status': 'Order Status',

        },
        dynamic: {
            'client_order_id': 'Order ID',
            'order_type': 'Order Type',
            'stop_price': 'Stop Price',
            // 'created': 'Time',
            'original_client_order_id': 'Original Order ID',
            'exchange_order_id': 'Exchange Order ID',
            'last_filled_qty': 'Last Filled Qty',
            'last_filled_price': 'Last Filled Price',
            'total_filled_qty': 'Filled Qty',
            'is_trigerred': 'Triggered Status',
            'order_category': 'Order Category',
            'childClCode': 'Child Cl Code',
            'order_validity': 'Validity',
            'error_text': 'Messages',
            'instrument_type': 'Instrument type',
            'generated_order_id': 'Generated Order ID',
            'placed_by': 'Placed By',
            'modified_by': 'Modified By'


        }
    },

    tradeBook: {
        static: {
            'history': 'History',
            'modified': 'Time',
            'side': 'Mode',
            'scrip_name': 'Symbol',
            'last_trade_price': 'Ltp',
            'market_id': 'Exchange',
            'product_type': 'Product',
            'last_filled_qty': 'Qty',
            'last_fill_price': 'Price',

        },
        dynamic: {
            'client_order_id': 'Order Id',
            // 'order_type',
            'status': 'Order Status',
            'exchange_order_id': 'Exchange Order Id',
            'primary_client_code': 'Primary Client Code',
            'trade_id': 'Trade Id',
            'order_validity': 'Order Validty',
            // not listed in mail. to be verified
            'instrument': 'Instrument type',
            'last_traded_amount': 'Last Traded Amount',
            'participant_code': 'Participant Code',
            'exchange_client_code': 'Exchange Client Code',
            'fix_cl_order_id': 'Fix Order Id',
            'clientId': 'Client Id',
            'order_category': 'Order Category',
            'placed_by': 'Placed By',
            'generated_order_id': 'Generated Order ID',

        }
        // 'strategy_id': 'Strategy'
    },

    positions: {
        static: {

            'action-btns': 'Action Buttons',
            'product_type': 'Product',
            'scrip_name': 'Symbol',
            'netQuantity': 'Net Qty',
            'net_price': 'Net Price',
            'last_trade_price': 'Ltp',
            'net_profit_loss': 'Net P/L'
        },
        dynamic: {
            'market_id': 'Exchange',
            'instrument': 'Instrument Type',
            'net_value': 'Net Value',
            'm2m': 'Net M2M P/L',
            //'day_m2m': 'Day M2M P/L', commenting as it is not required for now
            'booked_pl': 'Booked P/L',
            'buy_qty': 'Buy Qty',
            'buy_lots': 'Buy Lots',
            'buy_price': 'Avg Buy Price',
            'buy_amount': 'Buy Amount',
            'sell_qty': 'Sell Qty',
            'sell_lots': 'Sell Lots',
            'sell_price': 'Avg Sell Price',
            'sell_amount': 'Sell Amount',
            // 'series',
            'primary_client_code': 'Parent CI Code',
        }
        // 'exchange_client_code',
        // 'net_lots',
        // 'old_qty',
        // 'settlement_amount'
    },

    marginSummaryColumns: {
        static: {
            'client_code': 'Client Code',
            'cash': 'Cash',
            'cash_available': 'Cash Available',
            'collateral': 'Collateral',
            'net_mtm': 'Net MTM',
            'mtm_profit': 'MTM Profit',
            'delivery_selling_benefit': 'Delivery Selling Benefit',
            'booked_profit': 'Booked Profit',
            'pay_in': 'Pay In',
            'adhoc': 'AdHoc',
            'margin_utilized': 'Margin Utilized',
            'margin_percent': 'Margin Percent',
            'net_booked_profit_loss': 'Net Booked Profit Loss',
            'mtm_loss': 'MTM Loss',
            'mtm_percent': 'MTM Percent',
            'booked_loss': 'Booked Loss',
            'pay_out': 'Pay Out'
        },
        dynamic: {

        }
    },

    holdings: {
        static: {
            'action': 'Action Button',
            'symbol': 'Symbol',
            'total_qty': 'Total Qty',
            'last_trade_price': 'Ltp',
            'current_value': 'Current Value',
            'profit_loss': 'Profit Loss',
            'outStandingQty': 'Balance Qty',
            'isin': 'ISIN',
        },
        dynamic:
        {
            'pending_qty': 'Pending Qty',
            'sold_qty': 'Sold Qty',
            'close_price_value': 'Close Price',
            'average_price': 'Average Price',
            'investment_value': 'Invested Value',
            'client_id': 'Client Id',
            'avilableQty': 'Holding Qty',
            'collateral_qty': 'Total Collateral Qty',
            'collateralValue': 'Collateral Value',
            't1_qty': 'T1 Holding',
            'edis_auth_qty': 'Authorization Qty'
        }
    },
    backOffice_holdings: {
        static: {
            'ISINCode': 'ISIN',
            'ScripName': 'Company Name',
            'Stock': 'Stock',
            'DPBalance': 'Balance',
            'ClosRate': 'Close Rate'
        },
        dynamic: {}
    },

    client_fifo_contract: {
        static: {
            'EXCH': 'Exchange',
            'PAR_NAME': 'Name',
            'CLIENTCODE': 'Client Code',
            'SECURITYNAME': 'Script Name',
            'OPTIONTYPE': 'Index Type',
            'STRIKEPRICE': 'Strike Price',
            'JOBB_QTY': 'Jobbing Qty',
            'JOBB_PURVAL': 'Jobbing Purchase Qty',
            'JOBB_SALEVAL': 'Jobbing Sale Value',
            'JOBB_PL': 'Jobbing PnL',
            'DELV_QTY': 'Delivery Qty',
            'DELV_PURVAL': 'Delivery Purchase Value',
            'DELV_SALEVAL': 'Delivery Sale Value',
            'DELV_PL': 'Delivery PnL',
            'STOCK_QTY': 'Stock Qty',
            'STOCKVAL': 'Stock Value',
            'CLOSRATE': 'Close Rate',
        },
        dynamic: {}
    },

    client_fifo_expense: {
        static: {
            'STTAMT': 'STT Amount',
            'BROK': 'Brokerage',
            'STAMP': 'Stamp Duty',
            'SEBI': 'Sebi Tax',
            'TRXN': 'Transaction Charges',
        },
        dynamic: {
        }
    },

    daily_mtmBill: {
        static: {
            'NAME': 'Name',
            'TRN_DATE': 'Transaction Date',
            'DELVDATE': 'Delivery Date',
            'BILLNO': 'Bill No',
            'SH_NAME': 'Share Name',
            'PURQTY': 'Purchase Qty',
            'PUR_MKT': 'Purchase Market Rate',
            'PUR_NET': 'Purcahse Net Rate',
            'PURVALUE': 'Purchase Value',
            'SALEQTY': 'Sale Qty',
            'SALE_MKT': 'Sale Market Rate',
            'SALE_NET': 'Sale Net Rate',
            'SALEVALUE': 'Sale Value',
            'FLAG': 'Flag',
            'NSETAX': 'Transaction Charge',
            'BALANCE': 'Balance',
            'STTAMT': 'STT Amount',
            'DEMATCHRG': 'Demat Charge',
            'STAMPDUTY': 'Stamp Duty',
            'TAX1': 'SEBI TO Tax',
            'CGST': 'CGST',
            'SGST': 'SGST',
            'IGST': 'IGST',
            'DBROK': 'Brokerage',
        },
        dynamic: {}
    },

    daily_mtmBill_fo: {
        static: {
            'Date': 'Date',
            'CODE': 'Code',
            'NAME': 'Name',
            'EXCHANGE': 'Exchange',
            'SYMBOL': 'Symbol',
            'EXPIRYDATE': 'Expiry Date',
            'STRIKEPRICE': 'Strike Price',
            'OPTIONTYPE': 'Option Type',
            'BF_QTY': 'Brought Forward Qty',
            'BF_RATE': 'Brought Forward Rate',
            'BF_VALUE': 'Brought Forward Value',
            'PURQTY': 'Purchase Qty',
            'PUR_AVG_RATE': 'Purchase Average Rate',
            'PUR_VALUE': 'Purchase Value',
            'SALEQTY': 'Sale Qty',
            'SALE_AVG_RATE': 'Sale Average Rate',
            'SALE_VALUE': 'Sale Value',
            'NET_QTY': 'Net Qty',
            'AVGRATE': 'Average Rate',
            'NET_VALUE': 'Net Value',
            'CLOSE_RATE': 'Close Rate',
            'BILL_VALUE': 'Bill Value',
            'MTM_NOTIONAL': 'MTM Notional',
            'BROK': 'Brokerage',
            'TOTALSTT': 'STT',
            'STAMP': 'Stamp Duty',
            'TAX1': 'SEBI TO Charges',
            'TAX3': 'Transaction Charges',
            'CGST': 'CGST',
            'SGST': 'SGST',
            'IGST': 'IGST'
        },
        dynamic: {}
    },

    dp_transaction: {
        static: {
            'ISIN': 'ISIN',
            'SCRIP': 'Company Name',
            'WDATE1': 'Date',
            'NARR': 'Narration',
            'CREDIT': 'Credit',
            'DEBIT': 'Debit'
        },
        dynamic: {}
    },

    financial_ledger: {
        static: {
            'PostDate': 'Date',
            'Narration': 'Narration',
            'Debit': 'Debit',
            'Credit': 'Credit',
            'RunningBalance': 'Balance',
        },
        dynamic: {}
    },

    fund_summary: {
        static: {
            'PostDate': 'Date',
            'Narration': 'Narration',
            'Debit': 'Debit',
            'Credit': 'Credit',
            'RunningBalance': 'Balance',
        },
        dynamic: {}
    },

    net_positions: {
        static: {
            'ISINCODE': 'ISIN',
            'SH_NAME': 'Symbol',
            'PURQTY': 'Purchase Qty',
            'PUR_VALUE': 'Purchase Value',
            'SALEQTY': 'Sale Qty',
            'SALE_VALUE': 'Sale Value',
            'NET_QTY': 'Net Qty',
            'NET_VALUE': 'Net Value',
            'AVGRATE': 'Avg Rate',
            'CLOSE_RATE': 'Close Rate',
            'MTM': 'MTM',
        },
        dynamic: {}
    },
    net_positions_fo: {
        static: {
            'SYMBOL': 'Symbol',
            'EXPIRYDATE': 'Expiry Date',
            'STRK': 'Strike Price',
            'OPTIONTYPE': 'Option Type',
            'PURQTY': 'Purchase Qty',
            'PUR_VALUE': 'Purchase Value',
            'SALEQTY': 'Sale Qty',
            'SALE_VALUE': 'Sale Value',
            'NET_QTY': 'Net Qty',
            'NET_VALUE': 'Net Value',
            'AVGRATE': 'Avg Rate',
            'CLOSE_RATE': 'Close Rate',
            'MTM': 'MTM'
        },
        dynamic: {}
    },
    trade_summary: {
        static: {
            'TRN_DATE': 'Date',
            'SH_NAME': 'Company Name',
            'BS': 'Action',
            'TRN_QTY': 'Quantity',
            'RATE': 'Price',
            'TRADE_VALUE': 'Trade Value',
        },
        dynamic: {

        }
    },

    productConversionSummary: {
        static: {
            'symbol': 'Symbol',
            'market_id': 'Exchange',
            'security_id': 'SecurityId',
            'initiator': 'Performed By',
            'instrument_type': 'Instrument type',
            'quantity': 'Qty Converted',
            'source_product': 'Old Product',
            'target_product': 'New Product',
            'status': 'Status',
            'rejectionText': 'Rejection Text',
            'mode': 'Mode',
            'client': 'Client Id'
        },
        dynamic: {

        }
    },

    contractDocument: {
        static: {
            'date': 'Date',
            'document_name': 'Document Name',
            'document_url': 'Document',
        },
        dynamic: {
        }
    }
};

export const TAB_TO_USERBOOK_MAP = {
    'Order Book': 'orderBook',
    'Trade Book': 'tradeBook',
    'GTT': 'gtt',
    'Positions': 'positions',
    'Holding': 'holdings',
    'Product Conversion Summary': 'productConversionSummary'
};

export const TABLE_TO_EVENTS_MAP = {
    marketWatch: EVENTS.UPDATE_MARKET_WATCH_COLUMNS,
    orderBook: EVENTS.UPDATE_ORDER_BOOK_COLUMNS,
    tradeBook: EVENTS.UPDATE_TRADE_BOOK_COLUMNS,
    positions: EVENTS.UPDATE_POSITIONS_COLUMNS,
    holdings: EVENTS.UPDATE_HOLDINGS_COLUMNS,
    productConversionSummary: EVENTS.UODATE_PRODUCT_CONVERSION_SUMMARY,
    batchOrdersTable: EVENTS.UPDATE_BATCH_ORDERS_TABLE_COLUMNS
};

export const BATCH_SAVE_COUMNS = {
    'orderMode': 'side',
    'market': 'market',
    'client': 'client_id',
    'instrument': 'instrument',
    'symbol': 'symbol',
    'series': 'series',
    'securityId': 'security_id',
    'expiryDate': 'expiry_date',
    'optType': 'option_type',
    'strikePrice': 'strike_price',
    'orderType': 'order_type',
    'price': 'price',
    'triggerPrice': 'trigger_price',
    'quantity': 'quantity',
    'product': 'product_type',
    'validity': 'validity'
};

export const STICKY_ITEMS = {
    'Security Name': 'symbol',
    'Info': 'info',
    'History': 'history',
    'Action Buttons': 'action-btns',
    'Action Button': 'action',
    'Select': 'select',
};

export const SEARCH_PRECISION_COLUMNS = {

    orderBook: [
        'price',
        'stop_price',
        'last_filled_price'
    ],
    holdings: [
        'investment_value',
        'close_price_value',
        'collateralValue',
        'current_value',
        'profit_loss'
    ],
    positions: [
        'buy_price',
        'buy_amount',
        'sell_price',
        'sell_amount',
        'net_price',
        'net_value',
        'last_trade_price',
        'm2m',
        'booked_pl',
        'net_profit_loss'
    ],
    tradeBook: [
        'last_fill_price',
        'last_traded_amount',
    ]

};



export const ipoColumns = {
    bid_history_columns : ['scrip_id', 'investor_type', 'entry_time', 'dp_status'],
    list_columns: ['scrip_id', 'price_range', 'biding_dates', 'trading_lot', 'min_price', 'apply']
};
